import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertDateTimeFormat,
  resetForm,
} from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-access-point-activity-detail',
  templateUrl: './access-point-activity-detail.component.html',
  styleUrls: ['./access-point-activity-detail.component.scss'],
})
export class AccessPointActivityDetailComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() submitToParent = new EventEmitter();
  @Output() resetFilterData = new EventEmitter();
  @Input() isProfileActivityFilter!: boolean;

  formGroupUserName!: FormGroup;
  formGroupDateRange!: FormGroup;
  formGroupLocks!: FormGroup;
  formGroupLockIds!: FormGroup;
  filterLength: number = 0;

  readonly LANG_CONST = LANG_CONST;

  constructor(public rootFormGroup: FormGroupDirective) {}

  get dateFormat() {
    if (this.formGroupDateRange?.value?.dateTodateFrom) {
      return `${convertDateTimeFormat(
        this.formGroupDateRange.controls.dateTodateFrom.value.start,
        'yyyy/MM/dd'
      )} - ${convertDateTimeFormat(
        this.formGroupDateRange.controls.dateTodateFrom.value.end,
        'yyyy/MM/dd'
      )}`;
    }
  }
  ngOnInit(): void {
    this.formGroupUserName = this.rootFormGroup.control.get(
      'userName'
    ) as FormGroup;
    this.formGroupDateRange = this.rootFormGroup.control.get(
      'dateRange'
    ) as FormGroup;
    this.formGroupLocks = this.rootFormGroup.control.get('locks') as FormGroup;
    this.formGroupLockIds = this.rootFormGroup.control.get(
      'lockIds'
    ) as FormGroup;
  }

  getFormState() {
    const userCount =
      this.formGroupUserName.controls.searchEntity.value != '' ? 1 : 0;
    const dateCount =
      this.formGroupDateRange.controls.dateTodateFrom.value != '' ? 1 : 0;
    this.filterLength =
      this.formGroupLocks.controls.eventType.value.length +
      userCount +
      dateCount;
  }
  /**
   * @description navigation to next and previous stepper
   * @returns void
   */
  navigateTo(step: number): void {
    this.stepperChange.emit((this.stepper = step));
  }

  applyFilter() {
    this.submitToParent.emit(); //submit parent form
  }

  resetFilter() {
    resetForm(this.formGroupUserName as FormGroup);
    resetForm(this.formGroupDateRange as FormGroup);
    resetForm(this.formGroupLocks as FormGroup, []);
    resetForm(this.formGroupLockIds as FormGroup, []);
    this.resetFilterData.emit();
  }
}
